<template>
    <modal
        id="modal-checkin"
        size="md"
        :title="$t('checkIn.checkinsForecast')"
        :okTitle="$t('modal.save')"
        :okDisabled="isSubmitting"
        :cancelTitle="$t('modal.cancel')"
        :cancelDisabled="false"
        :noCloseOnEsc="true"
        :noCloseOnBackdrop="true"
        isModalRoute
        @okHandler="onSubmit"
    >
        <Loader :loader="isLoading" />
        <b-form v-if="!isLoading">
            <b-row
                :key="checkIn.id.$model"
                v-for="checkIn in $v.checkIns.$each.$iter"
            >
                <b-col sm="5" class="ml-4">
                    <b-form-group
                        :label="`${$t('form.label.forecast')}*`"
                        :label-for="`input-value-id-${checkIn.id.$model}`"
                        label-size="sm"
                        label-cols="2"
                        label-cols-sm="3"
                        label-cols-md="3"
                    >
                        <b-form-input
                            block
                            size="sm"
                            type="text"
                            :id="`input-value-id-${checkIn.id.$model}`"
                            :aria-describedby="
                                `input-value-id-${checkIn.id.$model}-feedback`
                            "
                            v-model="checkIn.value.$model"
                            class="ml-3"
                            :state="checkArrayState(checkIn, 'value')"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            :id="`input-value-id-${checkIn.id.$model}-feedback`"
                        >
                            <span v-if="!checkIn.value.required">{{
                                $t('form.validations.required')
                            }}</span>
                            <span v-if="!checkIn.value.decimal">{{
                                $t('form.validations.decimal')
                            }}</span>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="4" class="ml-5">
                    <b-form-group
                        :label="`${$t('form.label.date')}:`"
                        :label-for="`input-value-id-${checkIn.id.$model}`"
                        label-size="sm"
                        label-cols="12"
                        label-cols-sm="3"
                        label-cols-md="3"
                    >
                        <p class="m-1">
                            {{ checkIn.date.$model | formatDate }}
                        </p>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <template slot="okButton">
            <i v-if="isSubmitting" class="fa fa-spinner fa-spin px-2"></i>
        </template>
    </modal>
</template>

<script>
import Modal from '@/views/components/modal'
import Loader from '@/views/components/loader'
import notification, { success, danger } from '@/lib/notification'
import { getUserData } from '@/services/user-data'
import { validationMixin } from 'vuelidate'
import { required, decimal } from 'vuelidate/lib/validators'
import { getStringFromDateWithoutTime } from '@/lib/date'
import { getExpectancies, saveSimulatedCheckIns } from './api'
import { mapperExpectanciesToForm, mapperFormToApi } from './functions'

notification.init()

export default {
    name: 'CheckInSimulated',
    props: [],
    components: {
        Modal,
        Loader,
    },
    mixins: [validationMixin],
    validations: {
        checkIns: {
            required,
            $each: {
                id: {},
                value: {
                    required,
                    decimal,
                },
                expectation: {},
                date: {},
            },
        },
    },
    data() {
        return {
            isLoading: true,
            isSubmitting: false,
            indicatorType: null,
            indicatorId: null,
            checkIns: [],
            userId: null,
        }
    },
    mounted() {
        this.userId = getUserData().id
        if (this.$route.params.targetId) {
            this.indicatorId = this.$route.params.targetId
            this.indicatorType = 'target'
        } else if (this.$route.params.kpiId) {
            this.indicatorId = this.$route.params.kpiId
            this.indicatorType = 'kpi'
        }

        getExpectancies(this.indicatorId, this.indicatorType).then(resp => {
            this.checkIns = mapperExpectanciesToForm(resp.checkins)
            this.isLoading = false
        })
    },
    methods: {
        checkArrayState(current, key) {
            return current[key].$dirty ? !current[key].$invalid : null
        },
        onSubmit(event, closeModal) {
            event.preventDefault()

            if (this.validate()) {
                this.isSubmitting = true
                const form = mapperFormToApi(this.checkIns, this.userId)
                saveSimulatedCheckIns(
                    form,
                    this.indicatorId,
                    this.indicatorType
                )
                    .then(() => {
                        success()
                        this.$emit('update-parent', 'updateCheckin')
                        closeModal()
                    })
                    .catch(error => {
                        danger()
                        console.log(error)
                    })
                    .finally(() => {
                        this.isSubmitting = false
                    })
            }
        },
        validate() {
            this.$v.$touch()
            return !this.$v.$invalid
        },
    },
    filters: {
        formatDate(date) {
            return getStringFromDateWithoutTime(date, 'YYYY-MM-DD')
        },
    },
}
</script>
